import { createAction, props } from '@ngrx/store'

export const BUTTON_CLICK = '[BarButtons] Se ha seleccionado otro boton'
export const REST_BAR_BUTTONS_STATE = '[BarButtons] Se reinicia el estado barra de botones.'

export const buttonClick = createAction(BUTTON_CLICK, props<{ action: any }>())
export const resetBarButtonsState = createAction(REST_BAR_BUTTONS_STATE)
